import { combineReducers } from '@reduxjs/toolkit';
import { createCustomSlice } from '../store.utils';
import {
  registerUserAsyncThunk,
  loginUserAsyncThunk,
  googleAuthAsyncThunk,
  getMeAsyncThunk,
  requestResetPasswordAsyncThunk,
  resetPasswordAsyncThunk,
} from './users.action';
import { asyncSliceDefaultInitialState } from 'store/store.constants';
import { CURRENT_USER_LOCAL_STORAGE_KEY } from './users.constants';
import { safelyGetItem, safelySetItem } from 'utils/localStorage';

// ---------- REGISTER ----------
const registerUserSlice = createCustomSlice(
  'users/registerUser',
  registerUserAsyncThunk
);

// ---------- LOGIN ----------
const loginUserSlice = createCustomSlice(
  'users/loginUser',
  loginUserAsyncThunk
);

// ---------- GOOGLE AUTH ----------
const googleAuthSlice = createCustomSlice(
  'users/googleAuth',
  googleAuthAsyncThunk
);

// ---------- GET ME ----------
const getMeSlice = createCustomSlice(
  'users/getMe',
  getMeAsyncThunk,
  { hello: () => console.log('hello') },
  { afterReset: () => safelySetItem(CURRENT_USER_LOCAL_STORAGE_KEY, null) },
  {
    ...asyncSliceDefaultInitialState,
    data: safelyGetItem(CURRENT_USER_LOCAL_STORAGE_KEY),
  }
);

// ---------- REQUEST RESET PASSWORD ----------
const requestResetPasswordSlice = createCustomSlice(
  'users/requestResetPassword',
  requestResetPasswordAsyncThunk
);

// ---------- RESET PASSWORD ----------
const resetPasswordSlice = createCustomSlice(
  'users/resetPassword',
  resetPasswordAsyncThunk
);
export const { reset: resetRegisterUser } = registerUserSlice.actions;
export const { reset: resetLoginUser } = loginUserSlice.actions;
export const { reset: resetGoogleAuth } = googleAuthSlice.actions;
export const { reset: clearUser } = getMeSlice.actions;
export const { reset: resetRequestResetPassword } =
  requestResetPasswordSlice.actions;
export const { reset: resetResetPassword } = resetPasswordSlice.actions;

// ---------- COMBINED REDUCER ----------
export const usersReducer = combineReducers({
  registerUser: registerUserSlice.reducer,
  loginUser: loginUserSlice.reducer,
  googleAuth: googleAuthSlice.reducer,
  currentUser: getMeSlice.reducer,
  requestResetPassword: requestResetPasswordSlice.reducer,
  resetPassword: resetPasswordSlice.reducer,
});
